export default __webpack_public_path__ + "static/doc-blob-mobile-fe2f7a9609802ed60590b245a62fe482.png";